import React from 'react'
import DataTable from 'react-data-table-component';
import Recievedjournal from './recievedjournal';
import { FaCheckCircle } from 'react-icons/fa';
import PopUpCheckList from './popUpCheckList';


const columns = [
    {
        name: 'TDS code',
        sortable: true,
        selector: row => row.tdscode,
        grow: 0.5,
    },
    {
        name: 'V',
        selector: row => row.revision,
        grow: 0.1,
    },
    {
        name: 'Journal Type',
        selector: row => <div>
            {row.journaltype}
            <div style={{ color: 'red' }}>Create by : {row.createbyName}</div>
        </div>,
        grow: 1,
    },
    {
        name: 'customer / product',
        selector: row => <div>
            <div>: {row.customername}</div>
            <div>: {row.productname}</div>
            <div style={{ color: '#E85107' }}>: {row.productgrouptype}</div>
        </div>,
    },
    // {
    //     name: 'product name',
    //     sortable: true,
    //     selector: row => row.productname,
    // },

    {
        name: 'film code',
        selector: row => row.filmcode,
        grow: 0.5,
    },
    // {
    //     name: 'revision',
    //     selector: row => row.revision,
    //     grow: 0.3,
    // },
    // {
    //     name: 'product name',
    //     sortable: true,
    //     selector: row => row.productname,
    // },
    // {
    //     name: 'last film code',
    //     sortable: true,
    //     selector: row => row.filmcode,
    //     grow: 1,
    // },
    {
        name: 'confirm job',
        grow: 0.5,
        selector: row => <div>
            <div>{row.statusConfirm === '1' ? <label style={{ color: 'green' }}><FaCheckCircle /> Approve </label> : <label></label>}</div>
        </div>,
    },
    {
        name: 'createdate',
        selector: row => row.createdate,
        grow: 0.5,
    },
    {
        name: 'Action',
        grow: 1,
        cell: row => <div>
            {row.QuarityStatus > '0' ? <PopUpCheckList tdsCode={row.tdscode} /> : <Recievedjournal Id={row.journalId} stateflow={row.stateflow} statusflow={row.statusflow} />}

        </div>
    },

];

//tasknote

const customStyles = {
    headRow: {
        style: {
            border: 'none',
            backgroundColor: '#28B463'
        },
    },
    headCells: {
        style: {
            color: '#ffff',
            fontSize: '14px',
        },
    },
    rows: {
        highlightOnHoverStyle: {
            backgroundColor: 'rgb(230, 244, 244)',
            borderBottomColor: '#FFFFFF',
            borderRadius: '25px',
            outline: '1px solid #FFFFFF',
        },
    },
    pagination: {
        style: {
            border: 'none',
        },
    },
};


const Tablejournallistrecieved = ({ values }) => {
    var data = values;
    return (
        <DataTable
            columns={columns}
            data={data}
            // selectableRows
            pagination
            customStyles={customStyles}
            highlightOnHover

        />
    )
}

export default Tablejournallistrecieved